export const GET_ORAGANIZATION = 'get-organizations';
export const GET_ORAGANIZATION_RESULT = `${GET_ORAGANIZATION}/result`;
export const GET_ORAGANIZATION_QUERY = 'get-organization-query';
export const GET_ORAGANIZATION_ERROR = `${GET_ORAGANIZATION}/error`;

export const GET_ORAGANIZATION_REPORT = 'get-organizations-report';
export const GET_ORAGANIZATION_REPORT_RESULT = `${GET_ORAGANIZATION_REPORT}/result`;
export const GET_ORAGANIZATION_REPORT_ERROR = `${GET_ORAGANIZATION_REPORT}/error`;

export const DELETE_ORGANIZATION = 'delete-organizations';
export const DELETE_ORGANIZATION_RESULT = `${DELETE_ORGANIZATION}/result`;
export const DELETE_ORGANIZATION_ERROR = `${DELETE_ORGANIZATION}/error`;

export const GET_ORG_DELETION_READINESS = 'get-org-deletion-readiness';
export const GET_ORG_DELETION_READINESS_RESULT = `${GET_ORG_DELETION_READINESS}/result`;
export const GET_ORG_DELETION_READINESS_ERROR = `${GET_ORG_DELETION_READINESS}/error`;

export const GET_ORAGANIZATION_OUTBOUND_API = 'get-organizations-outbound-api';
export const GET_ORAGANIZATION_OUTBOUND_API_RESULT = `${GET_ORAGANIZATION_OUTBOUND_API}/result`;
export const GET_ORAGANIZATION_OUTBOUND_API_ERROR = `${GET_ORAGANIZATION_OUTBOUND_API}/error`;

export const GET_ALL_PERMISSION = 'get-permission';
export const GET_ALL_PERMISSION_RESULT = `${GET_ALL_PERMISSION}/result`;
export const GET_ALL_PERMISSION_ERROR = `${GET_ALL_PERMISSION}/error`;

export const GET_ROLES_DETAIL = 'get-config-roles';
export const GET_ROLES_DETAIL_RESULT = `${GET_ROLES_DETAIL}/result`;
export const GET_ROLES_DETAIL_ERROR = `${GET_ROLES_DETAIL}/error`;

export const GET_ORG_ROLES_DETAIL = 'get-config-org-role-permission';
export const GET_ORG_ROLES_DETAIL_RESULT = `${GET_ORG_ROLES_DETAIL}/result`;
export const GET_ORG_ROLES_DETAIL_ERROR = `${GET_ORG_ROLES_DETAIL}/error`;
export const GET_ORG_TEMPLATE_ROLES = 'get-config-template-roles';
export const GET_ORG_TEMPLATE_ROLES_RESULT = `${GET_ORG_TEMPLATE_ROLES}/result`;
export const GET_ORG_TEMPLATE_ROLES_ERROR = `${GET_ORG_TEMPLATE_ROLES}/error`;
export const UPDATE_ORG_TEMPLATE_ROLES = 'update-config-template-roles';
export const UPDATE_ORG_TEMPLATE_ROLES_RESULT = `${UPDATE_ORG_TEMPLATE_ROLES}/result`;
export const UPDATE_ORG_TEMPLATE_ROLES_ERROR = `${UPDATE_ORG_TEMPLATE_ROLES}/error`;

export const UPDATE_ORG_ROLES_DETAIL = 'update-config-org-role-permission';
export const UPDATE_ORG_ROLES_DETAIL_RESULT = `${UPDATE_ORG_ROLES_DETAIL}/result`;
export const UPDATE_ORG_ROLES_DETAIL_ERROR = `${UPDATE_ORG_ROLES_DETAIL}/error`;

export const UPDATE_ORG = 'update-org';
export const UPDATE_ORG_RESULT = `${UPDATE_ORG}/result`;
export const UPDATE_ORG_ERROR = `${UPDATE_ORG}/error`;

export const GET_ORG_CONFIG = 'get-org-config';
export const GET_ORG_CONFIG_RESULT = `${GET_ORG_CONFIG}/result`;
export const GET_ORG_CONFIG_ERROR = `${GET_ORG_CONFIG}/error`;

export const GET_ORG_TEMPLATE_CONFIG = 'get-org-template-config';
export const GET_ORG_TEMPLATE_CONFIG_RESULT = `${GET_ORG_TEMPLATE_CONFIG}/result`;
export const GET_ORG_TEMPLATE_CONFIG_ERROR = `${GET_ORG_TEMPLATE_CONFIG}/error`;

export const GET_ORG_TEMPLATES = 'get-org-templates';
export const GET_ORG_TEMPLATES_RESULT = `${GET_ORG_TEMPLATES}/result`;
export const GET_ORG_TEMPLATES_ERROR = `${GET_ORG_TEMPLATES}/error`;

export const SAVE_ORG_TEMPLATE = 'save-org-template';
export const SAVE_ORG_TEMPLATE_RESULT = `${SAVE_ORG_TEMPLATE}/result`;
export const SAVE_ORG_TEMPLATE_ERROR = `${SAVE_ORG_TEMPLATE}/error`;

export const UPDATE_ORG_TEMPLATE = 'update-org-template';
export const UPDATE_ORG_TEMPLATE_RESULT = `${UPDATE_ORG_TEMPLATE}/result`;
export const UPDATE_ORG_TEMPLATE_ERROR = `${UPDATE_ORG_TEMPLATE}/error`;

export const DELETE_ORG_TEMPLATE = 'delete-org-template';
export const DELETE_ORG_TEMPLATE_RESULT = `${DELETE_ORG_TEMPLATE}/result`;
export const DELETE_ORG_TEMPLATE_ERROR = `${DELETE_ORG_TEMPLATE}/error`;

export const DELETE_HUB_DEVICE = 'delete-hub-device';
export const DELETE_HUB_DEVICE_RESULT = `${DELETE_HUB_DEVICE}/result`;
export const DELETE_HUB_DEVICE_ERROR = `${DELETE_HUB_DEVICE}/error`;

export const ORGANIZATION_DEVICES = 'organization-device';
export const ORGANIZATION_DEVICES_RESULT = `${ORGANIZATION_DEVICES}/result`;
export const ORGANIZATION_DEVICES_ERROR = `${ORGANIZATION_DEVICES}/error`;

export const ORGANIZATION_LIST = 'organization-list';
export const ORGANIZATION_LIST_RESULT = `${ORGANIZATION_LIST}/result`;
export const ORGANIZATION_LIST_ERROR = `${ORGANIZATION_LIST}/error`;

export const ASSIGN_CAPS_TO_THE_ORGANIZATION = 'assign-caps-to-the-organization';
export const ASSIGN_CAPS_TO_THE_ORGANIZATION_RESULT = `${ASSIGN_CAPS_TO_THE_ORGANIZATION}/result`;
export const ASSIGN_CAPS_TO_THE_ORGANIZATION_ERROR = `${ASSIGN_CAPS_TO_THE_ORGANIZATION}/error`;

export const HUB_DEVICES = 'hub-device';
export const HUB_DEVICES_RESULT = `${HUB_DEVICES}/result`;
export const HUB_DEVICES_ERROR = `${HUB_DEVICES}/error`;

export const HUB_DEVICES_TYPES = 'hub-device-types';
export const HUB_DEVICES_TYPES_RESULT = `${HUB_DEVICES_TYPES}/result`;
export const HUB_DEVICES_TYPES_ERROR = `${HUB_DEVICES_TYPES}/error`;

export const HUB_DEVICES_SCALE_GRAPH = 'hub-device-scale-graph';
export const HUB_DEVICES_SCALE_GRAPH_RESULT = `${HUB_DEVICES_SCALE_GRAPH}/result`;
export const HUB_DEVICES_SCALE_GRAPH_ERROR = `${HUB_DEVICES_SCALE_GRAPH}/error`;

export const HUB_DEVICES_BPMONITOR_GRAPH = 'hub-device-bpmonitor-graph';
export const HUB_DEVICES_BPMONITOR_GRAPH_RESULT = `${HUB_DEVICES_BPMONITOR_GRAPH}/result`;
export const HUB_DEVICES_BPMONITOR_GRAPH_ERROR = `${HUB_DEVICES_BPMONITOR_GRAPH}/error`;

export const GET_ORG_STATE_HISTORY = 'get-org-state-history';
export const GET_ORG_STATE_HISTORYGET_ORG_CONFIG_RESULT = `${GET_ORG_STATE_HISTORY}/result`;
export const GET_ORG_STATE_HISTORY_ERROR = `${GET_ORG_STATE_HISTORY}/error`;

export const CHANGE_ORG_ADMINISTRATIVE_STATE = 'change-org-administrative-state';
export const CHANGE_ORG_ADMINISTRATIVE_STATE_RESULT = `${CHANGE_ORG_ADMINISTRATIVE_STATE}/result`;
export const CHANGE_ORG_ADMINISTRATIVE_STATE_ERROR = `${CHANGE_ORG_ADMINISTRATIVE_STATE}/error`;

export const LAUNCH_ORG = 'launch-org';
export const LAUNCH_ORG_RESULT = `${LAUNCH_ORG}/result`;
export const LAUNCH_ORG_ERROR = `${LAUNCH_ORG}/error`;

export const UNSUSPEND_ORG = 'unsuspend-org';
export const UNSUSPEND_ORG_RESULT = `${UNSUSPEND_ORG}/result`;
export const UNSUSPEND_ORG_ERROR = `${UNSUSPEND_ORG}/error`;

export const CLEAR_ORGANIZATION = 'clear-organization';
export const CLEAR_DATA = 'clear-data';
export const CLEAR_SUGGESTED_DATA = 'clear-suggested-data';
export const CLEAR_ERRORS = 'clear-errors';

export const LINK_ORGANIZATION = 'link-organization';
export const LINK_ORGANIZATION_RESULT = `${LINK_ORGANIZATION}/result`;
export const LINK_ORGANIZATION_ERROR = `${LINK_ORGANIZATION}/error`;

export const UNLINK_ORGANIZATION = 'unlink-organization';
export const UNLINK_ORGANIZATION_RESULT = `${UNLINK_ORGANIZATION}/result`;
export const UNLINK_ORGANIZATION_ERROR = `${UNLINK_ORGANIZATION}/error`;

export const GET_ORAGANIZATION_GROUPS = 'get-organization-groups';
export const GET_ORAGANIZATION_GROUPS_RESULT = `${GET_ORAGANIZATION_GROUPS}/result`;
export const GET_ORAGANIZATION_GROUPS_ERROR = `${GET_ORAGANIZATION_GROUPS}/error`;

export const CREATE_ORAGANIZATION_GROUP = 'create-organization-group';
export const CREATE_ORAGANIZATION_GROUP_RESULT = `${CREATE_ORAGANIZATION_GROUP}/result`;
export const CREATE_ORAGANIZATION_GROUP_ERROR = `${CREATE_ORAGANIZATION_GROUP}/error`;

export const EDIT_ORAGANIZATION_GROUP = 'edit-organization-group';
export const EDIT_ORAGANIZATION_GROUP_GROUP_RESULT = `${EDIT_ORAGANIZATION_GROUP}/result`;
export const EDIT_ORAGANIZATION_GROUP_ERROR = `${EDIT_ORAGANIZATION_GROUP}/error`;

export const ADD_ORG_TO_GROUP = 'add-org-to-group';
export const ADD_ORG_TO_GROUP_RESULT = `${ADD_ORG_TO_GROUP}/result`;
export const ADD_ORG_TO_GROUP_ERROR = `${ADD_ORG_TO_GROUP}/error`;

export const REMOVE_ORG_FROM_GROUP = 'remove-org-from-group';
export const REMOVE_ORG_FROM_GROUP_RESULT = `${REMOVE_ORG_FROM_GROUP}/result`;
export const REMOVE_ORG_FROM_GROUP_ERROR = `${REMOVE_ORG_FROM_GROUP}/error`;

export const DELETE_ORG_GROUP = 'delete-org-group';
export const DELETE_ORG_GROUP_RESULT = `${DELETE_ORG_GROUP}/result`;
export const DELETE_ORG_GROUP_ERROR = `${DELETE_ORG_GROUP}/error`;

export const GET_ORG_GROUP_USERS = 'get-org-group-users';
export const GET_ORG_GROUP_USERS_RESULT = `${GET_ORG_GROUP_USERS}/result`;
export const GET_ORG_GROUP_USERS_ERROR = `${GET_ORG_GROUP_USERS}/error`;

export const ADD_USER_TO_ORG_GROUP = 'add-user-to-org-group';
export const ADD_USER_TO_ORG_GROUP_RESULT = `${ADD_USER_TO_ORG_GROUP}/result`;
export const ADD_USER_TO_ORG_GROUP_ERROR = `${ADD_USER_TO_ORG_GROUP}/error`;

export const REMOVE_USER_FROM_ORG_GROUP = 'remove-user-from-org-group';
export const REMOVE_USER_FROM_ORG_GROUP_RESULT = `${REMOVE_USER_FROM_ORG_GROUP}/result`;
export const REMOVE_USER_FROM_ORG_GROUP_ERROR = `${REMOVE_USER_FROM_ORG_GROUP}/error`;

export const GET_REMINDER_CONFIGURATION = 'get-reminder-configuration';
export const GET_REMINDER_CONFIGURATION_RESULT = `${GET_REMINDER_CONFIGURATION}/result`;

export const GET_EFFECTIVE_REMINDER_CONFIGURATION = 'get-effective-reminder-configuration';
export const GET_EFFECTIVE_REMINDER_CONFIGURATION_RESULT = `${GET_EFFECTIVE_REMINDER_CONFIGURATION}/result`;

export const PATCH_REMINDER_CONFIGURATION = 'patch-reminder-configuration';
export const PATCH_REMINDER_CONFIGURATION_RESULT = `${PATCH_REMINDER_CONFIGURATION}/result`;

export const PREVIEW_REMINDER_CONFIGURATION = 'preview-reminder-configuration';
export const PREVIEW_REMINDER_CONFIGURATION_RESULT = `${PREVIEW_REMINDER_CONFIGURATION}/result`;

export const GET_CARE_PROVIDERS = 'get-care-providers';
export const GET_CARE_PROVIDERS_RESULT = `${GET_CARE_PROVIDERS}/result`;
export const GET_CARE_PROVIDERS_ERROR = `${GET_CARE_PROVIDERS}/error`;

export const GET_BLOCKING_ENROLLMENTS = 'get-blocking-enrollments';
export const GET_BLOCKING_ENROLLMENTS_RESULT = `${GET_BLOCKING_ENROLLMENTS}/result`;
export const GET_BLOCKING_ENROLLMENTS_ERROR = `${GET_BLOCKING_ENROLLMENTS}/error`;

export const GET_MANDATORY_TASKS = 'get-mandatory-tasks';
export const GET_MANDATORY_TASKS_RESULT = `${GET_MANDATORY_TASKS}/result`;
export const GET_MANDATORY_TASKS_ERROR = `${GET_MANDATORY_TASKS}/error`;

export const EDIT_MANDATORY_TASKS = 'edit-mandatory-tasks';
export const EDIT_MANDATORY_TASKS_RESULT = `${EDIT_MANDATORY_TASKS}/result`;
export const EDIT_MANDATORY_TASKS_ERROR = `${EDIT_MANDATORY_TASKS}/error`;
